import { render, staticRenderFns } from "./PaletteColors.vue?vue&type=template&id=348ee806"
import script from "./PaletteColors.vue?vue&type=script&lang=js"
export * from "./PaletteColors.vue?vue&type=script&lang=js"
import style0 from "./PaletteColors.vue?vue&type=style&index=0&id=348ee806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports